import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

import index from '../views/index.vue'
import product from '@/views/product.vue'
import about from '@/views/about.vue'
import question from '@/views/question.vue'
import settingapple from '@/views/setting/settingapple.vue'
import settinghw from '@/views/setting/settinghw.vue'
import settingLocal from '@/views/setting/settingLocal.vue'
import settingmi from '@/views/setting/settingmi.vue'
import settingoppo from '@/views/setting/settingoppo.vue'
import settingvivo from '@/views/setting/settingvivo.vue'






export default new Router({
  routes: [
    {
      path: '/index',
      component: index
    },
    {
      path: '/product',
      component: product,
      meta:{
        title:'私密聊天软件功能说明-好运吧'
      }
    },
    {
      path: '/about',
      component: about
    },
    {
      path: '/question',
      component: question
    },
    {
      path: '/settingapple',
      component: settingapple
    },
    {
      path: '/settinghw',
      component: settinghw
    },
    {
      path: '/settingLocal',
      component: settingLocal
    },
    {
      path: '/settingmi',
      component: settingmi
    },
    {
      path: '/settingoppo',
      component: settingoppo
    },
    {
      path: '/settingvivo',
      component: settingvivo
    },
    {
      path: '*',
      component: index
    },
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js